import Janus from 'janus-gateway'
import adapter from 'webrtc-adapter'
import log from './customLog.js'

export default class  {
    constructor(options) {
        this.cache(options)
        this.init()
    }
                
    cache(options) {
        this.settings = {
            ...this.defaults,
            ...options
        }
        this.settings.helpersCount=0
        this.settings.helpers=[]
        this.settings.master_id = null
        this.janus = null
        this.console = new log({name: 'janus'})
        this.console.log('settings', this.settings)
    }
                
    get defaults() {
        return {
            telSettings: {                
                id: "781",
                ip: "89.184.65.45",
                password: "7EM2y7GVXZnoJmSJ",
                port: "5060",
                wss_url: "wss://pbx.fleetsoft.pro/ws"
            },
        }
    }
                
    init() {
        // отключенаая телефония 
        if(this.settings.telSettings.is_disabled) { 
            this.console.error('init: телефония отключена', this.settings.telSettings.is_disabled)
            if(this.settings.registrationFailed) this.settings.registrationFailed('телефония отключена')
                return false
        }
        if(this.settings.telSettings) {
            this.janusInit()
            //this.events()
        } else {
            this.console.error('init: не все данные', this.settings.telSettings)
            if(this.settings.registrationFailed) this.settings.registrationFailed('не все данные')
        }
        return this
    }

    janusInit() {
        const {ip, port, id, password} = this.settings.telSettings
        Janus.init({
            //debug: "all",
            dependencies: Janus.useDefaultDependencies({ adapter: adapter }),
            callback: () => {
                this.connect(this.settings.telSettings.wss_url)
            }
        })
    }

    connect(server) {
        this.janus = new Janus({
            server: server,
            iceServers: null,
            success: () => {
                this.attachPlugin()
            },
            error: (error) => {
                this.console.error(error)
                this.settings.error(error)
            },
            destroyed: () => {
                //window.location.reload()
                this.settings.destroyed()
            }
        })
    }

    attachPlugin() {
        this.plugin = null
        this.janus.attach({
            plugin: "janus.plugin.sip",
            opaqueId: this.settings.telSettings.id,
            success: (plugin) => {
                this.plugin = plugin
                const register = this.getRegister()
                this.plugin.send(register)
            },
            onmessage: (msg, jsep) => {
                this.onMessage(this.plugin, {msg, jsep}, 'master')
            },
            onremotetrack: (track, mid, on, meta) => {
                this.onremotetrack(this.plugin,{track, mid, on, meta})                
            },
            onremotestream: (stream) => {
                this.onRemoteStream(stream)
            },
            oncleanup: () => {
                //console.log('oncleanup')
            },
            error: function (error) {
                this.console.error(error)
            },
        })        
    }

    onremotetrack(plugin, obj) {
        const {track, mid, on, meta} = obj
        //console.log({track, mid, on, meta});
        if (track.kind !== "audio") return

        // библиотека присылает on=false при удалении трека и при onmute (~2.5с тишины):
        // переприсоединять там нечего, а на переиспользованном handle можно
        // затереть живой поток следующего звонка
        if (!on) {
            this.console.log('onremotetrack: трек снят, привязку не меняем', {mid, meta})
            return
        }

        const stream = new MediaStream([track]);
        const id = plugin.id

        // привязку ставим ПЕРВОЙ: исключение в addAudio не должно оставить звонок без звука
        this.attachAudio(id, stream)

        try {
            if(this.settings.addAudio) this.settings.addAudio(id, {stream, mid})
        } catch (error) {
            this.console.error('onremotetrack: addAudio', error, {id, mid})
        }
    }

    /**
     * Привязка удалённого потока к <audio> элементу звонка.
     * Элемент рендерит Vue, поэтому его может ещё не быть в DOM — ждём с повторами.
     * plugin.id у последовательных звонков совпадает (handle переиспользуется), и во
     * время leave-анимации предыдущего звонка в DOM могут быть два элемента с одним id —
     * актуален последний.
     */
    attachAudio(id, stream, attempt = 0) {
        const maxAttempts = 40
        const nodes = document.querySelectorAll('#peervideom'+id)
        const _audio = nodes.length ? nodes[nodes.length - 1] : null

        if(!_audio || !_audio.isConnected) {
            if(attempt >= maxAttempts) {
                this.console.error('attachAudio: элемент не найден, звук не подключен', {id, attempt})
                return
            }
            setTimeout(() => this.attachAudio(id, stream, attempt + 1), 50)
            return
        }

        try {
            this.console.log('attachMediaStream', _audio, stream, {id, attempt});
            Janus.attachMediaStream(_audio, stream);
            const played = _audio.play()
            if(played && played.catch) played.catch(error => {
                this.console.error('attachAudio: autoplay заблокирован', error, {id})
            })
        } catch (error) {
            this.console.error('attachAudio', error, {id})
        }
    }

    onMessage(plugin, obj, janusid) {
        this.console.log('onMessage', {plugin, obj, janusid}, obj.msg["result"]);
        const {jsep,msg} = obj
        const callId = msg["call_id"];
        const result = msg["result"] || {};
        if (!result) {
            this.console.error('empty result', {obj});
            return
        }

        const message = result["event"] || '';

        // if(message == 'message' || message =='info' ) {
        //     const sender = result["displayname"] ? result["displayname"] : result["sender"];
        //     let content = result["content"];
        //     content = content.replace(new RegExp('<', 'g'), '&lt');
        //     content = content.replace(new RegExp('>', 'g'), '&gt');
        // }

        if (message) {
            switch (message) {
                case "registering":
                    break
                case "registered":
                    break
                case "registration_failed":
                    break
                case "calling":
                    break
                case "incomingcall":
                    plugin.isbizzy = true
                    // hasFreeHelper возвращает индекс, а для свободного helper #0 это 0:
                    // проверка через !0 считала его отсутствующим и плодила новый handle
                    // с регистрацией на АТС на каждый входящий звонок
                    if(this.hasFreeHelper() === -1) {
                        this.addHelper()
                    }
                    this.console.log('helpers: ' + this.linesState(), this.settings.helpers)
                    break
                case 'accepting': 
                    break
                case 'progress': 
                    if (jsep) {
                        plugin.handleRemoteJsep({
                            jsep: jsep,
                            error: (error) => {
                                this.console.error('progress handleRemoteJsep', error)
                            }});
                        }
                    break
                case 'accepted':
                    if (jsep) {
                        plugin.handleRemoteJsep({
                            jsep: jsep, 
                            error: (error) => {
                                this.console.error('handleRemoteJsep', error)
                            }
                        });
                    }
                    break
                case 'updatingcall': 
                    const _this = this
                    this.plugin.createAnswer({
                        jsep: jsep, 
                        tracks: [{type: 'audio', capture: true, recv: true}], 
                        success: function (jsep) {
                            let body = {request: "update"};
                            _this.plugin.send({message: body, jsep: jsep});
                        }, error: function (error) {
                            this.console.error(error)
                        }
                    });
                    break
                case 'message':
                    break
                case 'info':
                    break
                case 'notify': 
                    break
                case 'transferring':
                    break
                case 'hangup':
                    plugin.isbizzy = false
                    // сводка после освобождения: показывает, вернулась ли линия в пул
                    this.console.log('hangup, helpers: ' + this.linesState())
                break
            }

            const isMaster = janusid === 'master'

            switch (message) {
                case "registered":
                    // master_id есть только в регистрации master-сессии. Раньше событие
                    // от helper'а затирало его undefined, после чего все следующие
                    // helper'ы уже не могли зарегистрироваться
                    if(isMaster) {
                        this.settings.telSettings.master_id  = result["master_id"];
                        if(this.settings.registered) this.settings.registered()
                    }
                    this.console.success(`registered [${janusid}]: ${message}`, {msg, jsep}, {plugin});
                break
                case "registration_failed":
                    // сбой helper'а не должен гасить телефонию целиком: registrationFailed
                    // ставит telStatus=false и Tel.vue уничтожает TelWind вместе со всеми
                    // <audio> элементами прямо во время активного разговора
                    if(isMaster) {
                        if(this.settings.registrationFailed) this.settings.registrationFailed(msg.result.reason)
                    } else {
                        plugin.isbroken = true
                    }
                    this.console.error(`onMessage [${janusid}]: ${message} ` + msg.result.reason, {msg, jsep}, {plugin});
                break
                default:
                    this.console.log(`onMessage [${janusid}]: ${message}`, {msg, jsep}, {plugin});
                    this.settings.emitMessage(message, plugin, {msg, jsep})
                break
            }
        }
    }
    // helper обязан регистрироваться тем же username, что и master,
    // поэтому строка формируется в одном месте
    get masterUsername() {
        const {ip, id} = this.settings.telSettings
        return "sip:"+id+"@" + ip
    }

    getRegister() {
        const {ip, port, id, password} = this.settings.telSettings
        const sipserver = "sip:"+id+"@" + ip + ":" + port
        const username = this.masterUsername

        const register = {
            request: "register", username: username
        };
        register["secret"] = password;
        register["proxy"] = sipserver;
        return {message: register}
    }

    addHelper(helperCreated) {
        helperCreated = (typeof helperCreated == "function") ? helperCreated : Janus.noop;
        const _this = this
        const helpersCount = this.settings.helpersCount++;
        const helperId = helpersCount;
        this.settings.helpers[helperId] = {
            id: helperId, localTracks: {}, localVideos: 0, remoteTracks: {}, remoteVideos: 0
        };

        return new Promise((resolve, reject) => {
            this.janus.attach({
                plugin: "janus.plugin.sip",
                opaqueId: this.settings.telSettings.id,
                success: function (pluginHandle) {
                    _this.settings.helpers[helperId].sipcall = pluginHandle;
                    const message = "[Helper #" + helperId + "] Plugin attached! (" + _this.settings.helpers[helperId].sipcall.getPlugin() + ", id=" + _this.settings.helpers[helperId].sipcall.getId() + ")"
                    const {master_id} = _this.settings.telSettings
                    // тот же username, что у master, иначе АТС отклоняет регистрацию helper'а
                    const username = _this.masterUsername

                    if(!master_id) {
                        _this.console.error("[Helper #" + helperId + "] master_id отсутствует, регистрация невозможна", {master_id})
                        pluginHandle.isbroken = true
                        reject(new Error('master_id отсутствует'))
                        return
                    }

                    _this.settings.helpers[helperId].sipcall.send({
                        message: {
                            request: "register",
                            type: "helper",
                            username,	// We use the same username as the master session
                            master_id				// Then we add the ID of the master session, nothing else
                        }
                    });
                    _this.settings.helpers[helperId].sipcall.isbizzy = false
                    _this.console.log(message, {pluginHandle, helperId, helpersCount, message, master_id, username})
                    resolve(helperId);
                },

                error: function (error) {
                    const message = "[Helper #" + helperId + "]   -- Error attaching plugin..."+ error
                    _this.console.error(message, error)
                    // без reject getFreeHelper зависал бы навсегда
                    reject(error)
                },
                onmessage: function (msg, jsep) {
                    let error = msg["error"];
                    if (error) {
                        // здесь this — handle, а не наш класс: this.console.error падал
                        // с TypeError, из-за чего ошибки helper'ов терялись молча
                        const message = "[Helper #" + helperId + "]"
                        _this.console.error(message, error)
                        return;
                    }
                    _this.onMessage(_this.settings.helpers[helperId].sipcall, {msg, jsep}, helperId)
                },
                onremotetrack: function (track, mid, on) {
                    const message = "[Helper #" + helperId + "] Remote track (mid=" + mid + ") " + (on ? "added" : "removed") + ":"+ track
                    const plugin = _this.settings.helpers[helperId].sipcall
                    _this.onremotetrack(plugin,{track, mid, on})
                },
            })
        });
    }

    async getFreeHelper() {

        let helperId = this.hasFreeHelper()
        if(helperId === -1) {
            try {
                helperId = await this.addHelper()
            } catch (error) {
                this.console.error('getFreeHelper: не удалось создать helper', error)
                return null
            }
        }
        return this.settings.helpers[helperId]
    }

    /**
     * Диагностическая сводка занятости линий: по одному числу helpers.length
     * нельзя понять, освобождаются ли линии или одна из них залипла занятой.
     * master включён специально — последовательные звонки идут именно на него.
     */
    linesState() {
        const describe = (handle) => {
            if(!handle) return 'не подключена'
            if(handle.isbroken) return 'СБОЙ РЕГИСТРАЦИИ'
            return handle.isbizzy ? 'занята' : 'свободна'
        }

        const lines = [`master ${describe(this.plugin)}`]
        this.settings.helpers.forEach((helper, index) => {
            lines.push(`#${index} ${describe(helper && helper.sipcall)}`)
        })

        return `${this.settings.helpers.length} [${lines.join(', ')}]`
    }

    // возвращает индекс свободного helper'а либо -1.
    // важно: 0 — валидный индекс, поэтому вызывающий код обязан сравнивать с -1,
    // а не проверять результат на истинность
    hasFreeHelper() {
        let ret = -1
        this.settings.helpers.some ((helper,index) => {
            if( helper.sipcall && helper.sipcall.isbizzy != true && helper.sipcall.isbroken != true) {
                ret = index
                return true
            }
            return false
        })
        return ret
    }

    acceptIncomingCall(plugin, jsep, callback) {
        plugin.isbizzy = true
        return plugin.createAnswer({
            jsep: jsep, 
            tracks: [{type: 'audio', capture: true, recv: true}], 
            success: function (jsep) {
                plugin.send({message: {request: "accept"}, jsep: jsep})
                if(callback) callback()
            }, error: function (error) {
                this.console.error(error)
            }
        });
    }

    async makeCall(phoneNumber) {
        const helper = await this.getFreeHelper()
        if(!helper || !helper.sipcall) {
            this.console.error('makeCall: нет свободной линии', {phoneNumber})
            throw new Error('Нет свободной линии для исходящего звонка')
        }
        const plugin = helper.sipcall
        plugin.isbizzy = true
        // исходящий тоже занимает линию — без этой строки в логе виден только результат
        this.console.log('makeCall занял линию, helpers: ' + this.linesState())
        const tracks = [{type: 'audio', capture: true, recv: true}]
        const {ip} = this.settings.telSettings
        const uri = `sip:${phoneNumber}@${ip}`

        plugin.createOffer({
            tracks: tracks, 
            success: function (jsep) {
                plugin.send({message: {request: "call", uri}, jsep: jsep})
            }, error: function (error) {
                this.console.error(error)
            }
        });
        
        return {
            plugin_id: plugin.id,
            phoneNumber
        }
    }

    async makeTransfe(item) {
        const plugin =  item.plugin
        plugin.isbizzy = true
        const {ip, port} = this.settings.telSettings
        const uri =  'sip:'+item.number+'@'+ip+':'+port
        const msg = {
            request: "transfer",
            uri,
            replace: plugin.callId,
            test: 'this is addition array test'
        }
        plugin.send({message: msg});
        this.console.log('makeTransfe', msg);
    }

    async makeDtmfTransfer(item) {
        
        this.makeDtmf(item.plugin, item.number)
    }

    async makeDtmf(plugin, dtmfString) {
        plugin.dtmf({
            dtmf: {tones: ''+dtmfString},
            success: (message) => {
                this.console.log('Успешное makeDtmf:', {plugin}, dtmfString);
            },
            error: (error) => {
                this.console.error('Ошибка makeDtmf:', error);
            }
        });
    }

    async makehangup(_plugin) {
        _plugin.send({
            message: { request: "decline"},
            success: () => {
                this.console.log('сброс вызова');
            },
            error: (error) => {
                this.console.error('Ошибка при завершении вызова:', error);
            }
        });
        _plugin.hangup();
    }

    /**
     * Полное освобождение сеанса. Без него пересоздание janus в handleJanusError
     * копило параллельные сеансы и SIP-регистрации одного и того же абонента.
     */
    destroy() {
        this.settings.helpers = []
        this.settings.helpersCount = 0
        this.settings.telSettings.master_id = null
        this.plugin = null

        try {
            if(this.janus) {
                // cleanupHandles закрывает PeerConnection'ы всех handle'ов и отпускает микрофон.
                // unload не передаём: для websocket он молча закрывает сокет, не отправив
                // destroy, и сессия с SIP-регистрацией остаётся висеть на сервере.
                // notifyDestroyed=false — чтобы колбэк destroyed не запустил новый цикл init.
                this.janus.destroy({cleanupHandles: true, notifyDestroyed: false})
            }
        } catch (error) {
            this.console.error('destroy: janus.destroy', error)
        }
        this.janus = null
    }

    get ipPort() {
        return {
            ip: this.settings.telSettings.ip,
            port: this.settings.telSettings.port
        }
    }
    
}